import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CustomerRepresentativeModalComponent } from './customer-representative-modal.component';
import { CustomerRepresentativeComponent } from './customer-representative.component';

@NgModule({
    declarations: [
        CustomerRepresentativeComponent,
        CustomerRepresentativeModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        InputMaskModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerRepresentativeComponent,
        CustomerRepresentativeModalComponent
    ]
})

export class CustomerRepresentativeModule {}
